
import {Link} from 'react-router-dom'

/**
 * wrapper class for containing the required router imports for a specific
 * router inside the bundle, with the goal to have the least update problems
 * as possible
 *
 */

export default Link
